// extracted by mini-css-extract-plugin
export default {"root":"VendorProductMapping_root__UrumG","lhs":"VendorProductMapping_lhs__KH4fW","rhs":"VendorProductMapping_rhs__0--2b"};